/**
 * Returns a gap with a top margin of 1em.
 * 
 * @returns A gap with a top margin of 1em.
 */
export default function Gap() {
    return (
        <div style={{ marginTop: '1em' }}>
            
        </div>
    )
}